<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">{{ 'Next of Kin Details'.toUpperCase() }}</div>
      </v-col>
    </v-row>
    <v-form ref="form" v-model="dataValid">
      <v-row justify="space-between">
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Name" required :rules="textRules" :disabled="!canEdit" v-model="obj.name"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="phone" required :rules="textRules" :disabled="!canEdit" v-model="obj.phone"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select outlined dense label="Relationship" required :rules="textRules" :items="relationships" item-text="title" item-value="id" :disabled="!canEdit" v-model="obj.relationshipId"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Address" required :rules="textRules" :disabled="!canEdit" v-model="obj.address"></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{ noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-btn color="error" depressed @click="$refs.form.reset()" :disabled="!canEdit" v-if="(getApplicantFee == null || !getApplicantFee.cleared) && !noHeader">Reset</v-btn>
      <v-btn color="primary" depressed @click="saveData" :disabled="!dataValid || !canEdit" >{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>
<!--      <v-btn color="primary" depressed @click="saveData" :disabled="!dataValid || !canEdit" v-if="getApplicantFee == null || !getApplicantFee.cleared">{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>-->
      <v-btn color="info" depressed @click="success" v-if="!canEdit">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>
<script>
import ValidationRules from "@/shared/ValidationRules";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import StudentStatus from "@/shared/StudentStatus";

export default {
  name: "NextOfKinDetails",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data: () => ({
    textRules: ValidationRules.textRules,
    obj: {},
    dataValid: true,
    relationships: [],
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
  }),
  methods: {
    success() {
      this.$emit('success')
    },

    saveData(){

      this.loading = true
      Api.applicants.nextOfKinUpdate(this.getUser.id, this.obj)
          .then(res => {
            this.message = 'Next of kin details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.$store.commit('setInformation', res.data)
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    check() {
        this.loading = true;
        Api.applicants.nextToNextOfKinDetails(this.getUser.id).then((res) => {
          this.loading = true;
          this.$store.commit("setCurrentUser", res.data)
        }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false )
    },

    loadBasicInfo(){
      this.loading = true
      Api.basicInformation.getAll()
          .then(res => {
            this.relationships = res.data.relationships
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    prefillData() {
      if (this.getInformation != null) {
        let i = this.getInformation
        this.obj.name = i.nextOfKinName
        this.obj.phone = i.nextOfKinPhone
        this.obj.address = i.nextOfKinAddress
        if(i.nextOfKinRelationship)
          this.obj.relationshipId = i.nextOfKinRelationship.id
      }
    }
  },

  watch:{
    getUser: function(){
      if(this.getUser != null && this.getUser.admission.applicationType.nextOfKinDetailsEnabled === false){
        this.success()
      }
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getInformation', 'getApplicantFee']),
    canEdit: function(){
      // status still not upto application complete
      return this.getUser != null && (StudentStatus[this.getUser.studentStatus].value <= StudentStatus.APPLICATION_PENDING.value)
    }
  },

  created() {
    if(this.getUser != null) {
      if(this.getUser.admission.applicationType.nextOfKinDetailsEnabled === false){
        this.success();
      }

      else{
        this.prefillData();
        this.check();
      }
    }

    // if(this.getInformation != null && this.getInformation.nextOfKinRelationship != null) {
    //   this.success()
    //   return
    // }
    this.loadBasicInfo()
    this.noHeader && this.$emit('update-title', "Next of Kin Details")
  }
}
</script>

<style scoped>

</style>
